export default __webpack_public_path__ + "static/media/icon_seas.a6416a77.svg";